module.exports = __webpack_public_path__ + "static/media/expertise.92f754ea.png";